module.exports = __webpack_public_path__ + "static/media/rishabh ji_page-0001.c7646e0d.jpg";